<div class="ui modal"
     id="Standings_Modal">
  <div class="standings-modal-row">
    <button class="ui button terminalButton" (click)="modalHide()">
      X
    </button>
  </div>

  <iframe [src]="iframe_src"
          width="50%"
          height="100%"
          title=""></iframe>

</div>
